import IReadingPlanRecord from "../interfaces/IReadingPlanRecord";
import { ReadingPlanCodes, createDefaultReadingPlanRecord } from "./ReadingPlans";

// Depreciated: This still exists for legacy purposes.
// Please use createDefaultReadingPlanRecord() directly now.
export const DefaultReadingPlanRecord: IReadingPlanRecord = createDefaultReadingPlanRecord(ReadingPlanCodes.ccrbrp);